
import RightSidebar from "./RightSidebar";
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import { utilityService } from "../requests/utilityService";
import { requestService } from "../requests/requestService";
import config from './config';
import axios from "axios";
import { useFinalReview } from "../hooks/useFinalReviewData";
import FloatingQueryCenter from "./FloatingQueryCenter";
import {
  saveMLNOComments,
  sendMailToUser,
  deactivateRequestAndCleanup,
  saveUserConsideration,
} from '../requests/finalReviewApi'; // adjust path if needed

import { riskAssesContObservable } from '../observers/riskAssesContObservable';

import { userSession } from "../observers/userObserver";
import SignatureCanvas from 'react-signature-canvas';
import "./TransactionDetail.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Contact } from "lucide-react";
import { sharedData } from '../sharedData/sharedData';
import { diligenceObservable } from "../observers/deligenceObservable";
import FloatingMessageCenter from "./FloatingMessageCenter";
import { EmailSuccess, EmailFailed } from "../components/popups/allPopup";
import DeleteConfirmationModal from "./ui/DeleteConfirmationModal";
import SignatureModal from "./ui/SignatureModal";
import LoaderModal from './Loader';
import ConfirmationModal from "./ui/ConfirmationModal";
import DiligenceChangeModal from "./ui/DiligenceChangeModal";
import { generateDefaultReportData } from "./generateReportData";
import ViewModeBanner from "./ui/ViewModeBanner";


const FinalReview = () => {
  // const [requestId, setRequestId] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isFetchingRef = useRef(false); // 🔁 Track ongoing fetch
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isSignatureModalOpen, setSignatureModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const token = userSession.getToken()

  // MLNO Diligence Override Modal State
  const [showOverrideModal, setShowOverrideModal] = useState(false);
  const [overrideNewStatus, setOverrideNewStatus] = useState("");

const isViewMode = searchParams.get("view") === "true";
  const showLoader = (message) => {
    setLoadingMessage(message);
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
    setLoadingMessage('');
  };


  const fetchMLNOData = async () => {
    const token = userSession.getToken()
    try {
      const response = await fetch(`${config["backend-url"]}/get_mlno_by_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ requestId })
      });

      if (!response.ok) throw new Error("Failed to fetch MLNO data");

      const data = await response.json();
      if (data.mlno) {
        setSignature(data.mlno.Signature || "");
        setFormData(prev => ({
          ...prev,
          justification: data.mlno.Justification || "",
          MLNOCOnsideration: data.mlno.MLNOConsideration || "",
          mlnoComments: data.mlno.MLNOComments || "",
          signature: data.mlno.Signature || "",
          status: data.mlno.Status || ""
        }));

        setIsChecked(data.mlno.Status === "Validated");
        setShowSignatureContainer(true);
      }
    } catch (error) {
      console.error("❌ Error fetching MLNO data:", error);
    }
  };



  // const [finalReviewInfo, setfinalReviewInfo] = useState({});
  const [SellerShowDropdown, setSellerShowDropdown] = useState(false);
  const [showTextarea, setShowTextarea] = useState(false);
  const [hasMortgage, setHasMortgage] = useState(null);
  const [requestStatusType, setRequestStatusType] = useState("");

  // const [statuses, setStatuses] = useState({});
  const navigate = useNavigate();

  const [requiredDocuments, setRequiredDocuments] = useState("Yes"); // Change to "No" to test
  const [pagesValidated, setPagesValidated] = useState("Yes"); // Change to "No" to test
  const [showExtraButtons, setShowExtraButtons] = useState(false);
  // const [signature, setSignature] = useState(null);
  // const [uploadedSignature, setUploadedSignature] = useState(null);
  // const [showSignatureContainer, setShowSignatureContainer] = useState(false);
  const sigPad = useRef({});
  const saveSignature = () => {
    const canvas = sigPad.current.getCanvas(); // untrimmed
    setSignature(canvas.toDataURL("image/png"));
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [modalHeading, setModalHeading] = useState("");
  const {
    requestId,
    statuses,

    signature,
    uploadedSignature,
    setUploadedSignature,
    showSignatureContainer,
    isChecked,
    setIsChecked,
    diligenceLevel,
    requestStatus,
    requsetStatusType,
    setRequestStatus,

    canFinalize,
    setSignature,
    setCanFinalize,
    setShowSignatureContainer,
    checkFinalizeAvailability,
    setStatuses,
    setRequiredDocumentsAttached,
    isReadOnly,
    setRefreshDocs,
    modalMessage,
    setModalMessage,
    isEmailModalOpen,
    setIsEmailModalOpen,
    formData,
    setFormData,
    finalReviewInfo,
    MLNOFlag,
    requiredDocumentsAttached

  } = useFinalReview(); // ✅ Correct usage — no arguments



  const clearSignature = () => {
    sigPad.current.clear();

    setSignature(null);
  };

  const handleUploadSignature = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedSignature(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  // Check if both conditions are met
  const isDisabled = requiredDocumentsAttached !== true || pagesValidated !== "Yes";

  const handleSelection = (event) => {
    setShowTextarea(event.target.value === "Yes");
  };



  const sendMail = async (userType) => {
    showLoader('Sending email, please wait...');
    try {
      const payload = {
        requestId: requestId,
        userType: userType
      };

      const data = await utilityService.sendMail(payload);
      setModalMessage(<EmailSuccess />);
    } catch (error) {
      console.error("❌ Failed to send email:", error);
      setModalMessage(<EmailFailed />);
    } finally {
      hideLoader();
      setModalOpen(true);
    }
  };




  useEffect(() => {
    if (statuses && Object.keys(statuses).length > 0) {
      const ready = checkFinalizeAvailability(statuses);
      setCanFinalize(ready);
    }
  }, [statuses, requiredDocumentsAttached, pagesValidated]);

  const handleClick = () => {
    if (diligenceLevel === "Enhanced") {
      navigate(`/Edd?${searchParams.toString()}`);
    }
  };

  const handleDiligenceChange = (newStatus) => {
    setOverrideNewStatus(newStatus);
    setShowOverrideModal(true);
  };

  const handleOverrideConfirm = async () => {
    // Close modal immediately when user clicks Confirm
    setShowOverrideModal(false);
    setOverrideNewStatus("");

    showLoader("Updating diligence status...");
    try {
      // Reset diligence observable
      diligenceObservable.reset();

      // Set new status
      diligenceObservable.setValue(overrideNewStatus, 'mlnoOverride');

      // Update diligence status using the same API endpoint
      await utilityService.updateDiligenceStatus(entityId, overrideNewStatus);

      // Update request
      await requestService.updateRequest({
        requestId: requestId,
        Diligence_Status: overrideNewStatus
      });

      console.log(`✅ Diligence status changed: ${diligenceLevel} → ${overrideNewStatus}`);

      hideLoader();
      setModalMessage("Diligence status has been successfully updated.");
      setModalOpen(true);

      // Reload page to reflect changes
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      console.error('❌ Error during diligence status change:', err);
      hideLoader();
      setModalMessage("Failed to update status. Please try again.");
      setModalOpen(true);
    }
  };
  const handleUpdate = () => {
    if (!isDisabled) {
      setShowExtraButtons(true); // Set state to show other buttons
    }
  };

  const handleValidate = () => {

    navigate("/Report");
  };

  const handleNext = () => {
    navigate("/Report");
    // console.log("Detail Clicked");
  };

  const handleDownloadDocuments = async () => {
  try {
    const response = await fetch(`${config['backend-url']}/get_blob_zip_by_request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userSession.getToken() || ''}`
      },
      body: JSON.stringify({ requestId: sharedData.get("requestId") }),
    });

    if (!response.ok) throw new Error("Failed to download documents");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Documents_${sharedData.get("requestId")}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error downloading documents:", err);
  }
};


  const handleDownloadReport = async () => {
  try {
    const requestId = sharedData.get("requestId");

    const response = await fetch(`${config['backend-url']}/download_report/${requestId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${userSession.getToken() || ''}`
      }
    });

    if (!response.ok) throw new Error("Failed to download report");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Combined_Report_${requestId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error downloading report:", err);
  }
};


  const displayStatus = (value) => {
    if (value === undefined) return "Loading...";
    if (value === null) return "N/A";
    if (value === "" || value === "Not Found") return "Not Validated";
    return value;
  };

  useEffect(() => {
    const requestId = sharedData.get("requestId"); // Replace this with however you're getting the request_id
  
    if (requestId) {
      initFinalReview(requestId);
    }
  }, []);

  const getStoredValues = () => {
    try {
      let entityId = sharedData.get("entityId") || null;
      let requestId = sharedData.get("requestId") || null;
      const email = userSession.getUserEmail() || null;
      return { entityId, requestId, email };
    } catch (error) {
      console.error("❌ Error retrieving stored values:", error);
      return { entityId: null, requestId: null, email: null };
    }
  };

  const getMergedUpdatedDocs = async () => {
    const mergedData = {};
    const { entityId, requestId, email } = getStoredValues(); // Assumes this returns valid requestId and email
    const currentPage = location.pathname.replace("/", ""); // Remove leading slash

    try {
      const res = await fetch(
        `${config["backend-url"]}/get-required?page=${currentPage}&requestId=${requestId}&email=${email}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${userSession.getToken()}`, // Use token from userSession
          }
        }
      );

      if (res.ok) {
        const data = await res.json();
        Object.assign(mergedData, data); // merge fetched data
        console.log("mergedData in res:", mergedData);
      } else {
        console.warn("Failed to fetch required docs");
      }
    } catch (err) {
      console.error("Error fetching required docs:", err);
    }

    // ✅ Always set mergedData in localStorage, even if it's still {}
    const finalPageKey = "updatedDocs-/FinalReview";
    localStorage.setItem(finalPageKey, JSON.stringify(mergedData));

    return mergedData;
  };


  const getLoadedDocKeys = async () => {
    try {
      const pageName = window.location.pathname;
      const { entityId, requestId, email } = getStoredValues();  // Assuming getStoredValues is available

      const response = await axios.get(`${config['backend-url']}/documents`, {
        params: { page_name: pageName, entityId, requestId, email },
        headers: {
          Authorization: `Bearer ${userSession.getToken()}`, // Use token from userSession
        }
      });

      if (response.status === 200 && Array.isArray(response.data)) {
        console.log("response:", response);

        const docKeys = response.data.map(doc => {
          if (pageName === "/FinalReview" && doc.is_optional === false) {
            // const pageKey = doc.page_name?.startsWith("/") ? doc.page_name.substring(1) : doc.page_name || "unknown";
            // return `${pageKey}-${doc.document_type}`;
            return doc.document_type;
          } else {
            return doc.document_type;
          }
        });

        localStorage.setItem("loadedDocs", JSON.stringify(docKeys));
        console.log("localStorage after loaded:",localStorage)
        return docKeys;
      } else {
        return [];
      }
    } catch (error) {
      console.error("❌ Error fetching doc keys:", error);
      return [];
    }
  };

  const isSendBackEnabled =
    !!formData.justification?.trim() &&
    !!formData.MLNOCOnsideration?.trim() &&
    !!formData.mlnoComments?.trim();

  console.log("isSendBackEnabled:", isSendBackEnabled);

  const sendMailToUser = async () => {
    setIsChecked(false); // optional UI reset
    showLoader("Sending to User, please wait...");
    try {
      const token = userSession.getToken()
      const userEmail = userSession.getUserEmail()


      // ✅ Step 1: Save MLNO comment with approved: false
      const savePayload = {
        requestId: requestId,
        justification: formData.justification || "",
        mlnoConsideration: formData.MLNOCOnsideration,
        mlnoComments: formData.mlnoComments,
        signature: uploadedSignature || signature,
        approved: false, // ❗ Explicitly set approval to false
      };

      const saveResponse = await fetch(`${config["backend-url"]}/save_mlno_comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(savePayload),
      });

      if (!saveResponse.ok) throw new Error("Failed to save MLNO review before sending email");

      // ✅ Step 2: Send mail to user
      const mailPayload = {
        requestId: requestId,
        comment: formData.mlnoComments,
        userEmail: userEmail,
      };

      const mailResponse = await fetch(`${config["backend-url"]}/send_mlno_comment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(mailPayload),
      });

      if (!mailResponse.ok) throw new Error("Failed to send MLNO comment email");

      setModalMessage(<EmailSuccess />);
      await fetchMLNOData(requestId);
    } catch (error) {
      console.error("❌ sendMailToUser error:", error);
      setModalMessage(<EmailFailed />);
    } finally {
      hideLoader();
      setModalOpen(true);
    }
  };

  const userType = localStorage.getItem("UserType");


  const handleValidateAndComplete = async () => {
    const missing = [];
    if (!formData.MLNOCOnsideration?.trim()) missing.push("Additional User Consideration");
    if (!formData.mlnoComments?.trim()) missing.push("MLNO Comments");
    if ((isEddValid || isRiskValid) && !formData.justification?.trim()) missing.push("EDD or Risk Assessment Justification");

    if (missing.length > 0) {
      setModalMessage(
        <div>
          <strong>Please complete the following required fields before finalizing:</strong>
          <ul style={{ margin: "10px 0", paddingLeft: "20px", textAlign: "left" }}>
            {missing.map((field, i) => <li key={i}>{field}</li>)}
          </ul>
        </div>
      );
      setModalOpen(true);
      return;
    }

    await saveMLNOComments();
    setSignatureModalOpen(true);
  };




  const handleDelete = async () => {
    // Logic to delete the item or draft
    //const confirmed = window.confirm("Are you sure you want to delete?");
    console.log("open Delete modal")
    setDeleteModalOpen(true);

  };
  const handleDeleteConfirm = async () => {
    setDeleteModalOpen(false);

    try {
      // Proceed with delete logic
      console.log("Deleting the entry...");

      await deactivateRequestAndCleanup(requestId);
      navigate("/dashboard");
      console.log("Item deleted.");
    } catch (error) {
      console.error("Error deleting item:", error);
      // Optionally show an error message to the user
    }
  };

  useEffect(() => {
    console.log("formData changed:", formData);
  }, [formData]);

  const handleDeletClose = () => {
    setDeleteModalOpen(false);
  };

  const entityId = useMemo(() => sharedData.get("entityId"), []);
  // const requestId = useMemo(() => sharedData.get("requestId"), []);
  const [isFinalCompleted, setisFinalCompleted] = useState(false);

  const saveMLNOComments = async () => {
    console.log(signature, "signature");
    const payload = {
      requestId: requestId,
      justification: formData.justification,
      mlnoConsideration: formData.MLNOCOnsideration,

      mlnoComments: formData.mlnoComments,
      signature: uploadedSignature || signature,

    }
    try {
      const response = await fetch(`${config["backend-url"]}/save_mlno_comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to save MLNO comments");

      const data = await response.json();
      console.log("✅ MLNO comments saved:", data);
      setModalMessage("MLNO comments saved successfully.");
      setIsEmailModalOpen(true);
    } catch (error) {
      console.error("❌ Error saving MLNO comments:", error);
      setModalMessage("Failed to save MLNO comments.");
      setIsEmailModalOpen(true);
    }
  };


  // Save user consideration notes (for non-MLNO users)
  const handleSaveUserConsideration = async () => {
    if (!formData.MLNOCOnsideration?.trim()) {
      setModalMessage("Please fill in the 'Additional User Consideration' field before saving.");
      setModalOpen(true);
      return;
    }
    try {
      await saveUserConsideration({
        requestId: requestId,
        mlnoConsideration: formData.MLNOCOnsideration,
      });
      setModalMessage("User consideration saved successfully.");
      setIsEmailModalOpen(true);
    } catch (error) {
      console.error("❌ Error saving user consideration:", error);
      setModalMessage("Failed to save user consideration.");
      setIsEmailModalOpen(true);
    }
  };

  /////////////////////
  const initFinalReview = async (request_id) => {
    try {
      const statusesResp = await fetch(`${config["backend-url"]}/get-all-statuses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ request_id })
      });

      if (statusesResp.ok) {
        const result = await statusesResp.json();
        // Server statuses as-is — see the same note in useFinalReviewData.js. It returns
        // "Not Applicable" for Corporate/Management when Simplified skips them.
        const serverStatuses = result.statuses || {};
        setStatuses(serverStatuses);
        const ready = checkFinalizeAvailability(serverStatuses);
        setCanFinalize(ready);
      }
      

      const updatedDocs = await getMergedUpdatedDocs();

      const updatedKeys = Object.keys(updatedDocs).filter(
        (key) => !key.includes("Optional")  // ✅ Updated condition
      );
      const loadedDocKeys = await getLoadedDocKeys();
      const allPresent = updatedKeys.every(key => loadedDocKeys.includes(key));
      setRequiredDocumentsAttached(allPresent);
    } catch (err) {
      console.warn("⚠️ Error initializing final review:", err.message);
    }
  };













  const handleSubmitMLNOReview = async () => {
    console.log("finalized request")
    const missingJustification = (isEddValid || isRiskValid) && !formData.justification;
    const missingConsideration = !formData.MLNOCOnsideration?.trim();
    const missingComments = !formData.mlnoComments?.trim();
    const missingSignature = !signature && !uploadedSignature;
    setSignatureModalOpen(false);
    if (
      missingJustification ||
      missingConsideration ||
      missingComments ||
      missingSignature ||
      !isChecked
    ) {
      setModalMessage(
        <strong>Please complete all required MLNO fields, including justification, comments, signature, and approval checkbox.</strong>
      );
      setIsEmailModalOpen(true);
      return;
    }

    const payload = {
      requestId,
      justification: formData.justification || "",
      mlnoConsideration: formData.MLNOCOnsideration,
      mlnoComments: formData.mlnoComments,
      signature: uploadedSignature || signature,
      approved: isChecked,
    };

    try {
      const response = await fetch(`${config["backend-url"]}/save_mlno_comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to save MLNO review");

      const result = await response.json();
      navigate("/Report");
      console.log("✅ MLNO review saved:", result);
      setModalMessage("MLNO review saved successfully.");
    } catch (error) {
      console.error("❌ MLNO review save error:", error);
      setModalMessage("Failed to save MLNO review.");
    } finally {
      setIsEmailModalOpen(true);
    }

  };


  const unlockSection = async (section) => {
    console.log("Unlocking section:", section);
    console.log("Request ID:", requestId);
    console.log("Entity ID:", entityId);

    try {
      const response = await fetch(`${config["backend-url"]}/unlock_section_status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          requestId,
          entityId,
          section,
        }),
      });


      if (!response.ok) {
        throw new Error("Failed to unlock section");
      }


      const data = await response.json();
      initFinalReview(requestId); // Re-fetch statuses after unlocking
      console.log("✅ Section unlocked successfully:", data);

      // Optionally refresh UI or table here (e.g. fetchTableData())

    } catch (error) {
      console.error("❌ Error unlocking section:", error);
    }
  };



  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCancel = () => {
    // Logic for Cancel button
    setSignatureModalOpen(false);
    setIsChecked(false);
  };

  const rawEddStatus = statuses.edd_status;
  const rawRiskStatus = statuses.risk_assessment_continued_status;
  const eddStatus = (rawEddStatus || "").toLowerCase();
  const riskStatus = (rawRiskStatus || "").toLowerCase();
  // console.log("Raw EDD Status:", rawEddStatus);
  // console.log("Raw Risk Status:", rawRiskStatus);
  // console.log("Normalized EDD:", eddStatus);
  // console.log("Normalized Risk:", riskStatus);

  const isEddValid = !["n/a", "in progress", "not validated"].includes(eddStatus);
  const isRiskValid = !["n/a", "in progress", "not validated"].includes(riskStatus);

  const saveFinalReport = async (finalReportData) => {
    try {
      const { entityId, requestId, email } = getStoredValues();
      const token = userSession.getToken();
      const payload = {
        finalReportData: finalReportData,
        requestId: requestId,
        email: email,
      };
      // console.log("requestId in save report:",requestId,email,token)
      const response = await fetch(`${config["backend-url"]}/final-report-save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to save report");

      const result = await response.json();
      console.log("✅ Save result:", result.message);
    } catch (error) {
      console.error("❌ Error saving final report:", error);
    }
  };

  const sendTOMnlno = async () => {
    if (!formData.MLNOCOnsideration?.trim()) {
      setModalMessage("Please fill in the 'Additional User Consideration' field before sending to MLNO.");
      setModalOpen(true);
      return;
    }

    const sharedData = JSON.parse(localStorage.getItem("sharedData")) || {};
    const request_id = sharedData?.requestId;

    if (!request_id) {
      console.warn("❌ Request ID not found in localStorage.sharedData.");
      return;
    }

    const token = userSession.getToken(); // Assuming you store it like this

    if (!token) {
      console.warn("❌ Authorization token not found in localStorage.");
      // alert("You are not authorized. Please login again.");
      setModalMessage("You are not authorized. Please login again.");
      setModalOpen(true);
      return;
    }

    try {
      showLoader("Sending to MLNO, please wait...");
      const response = await fetch(`${config["backend-url"]}/finalize_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ request_id, mlnoConsideration: formData.MLNOCOnsideration }),
        credentials: "include", // optional: use if Flask session handling needed
      });

      if (response.ok) {
        const result = await response.json();

        // 1. Generate default data from all form sources
        // const defaultData = await generateDefaultReportData();
        // console.log("defaultData IN FINAL REVIEW:", defaultData)
        // 2. Save the report to backend/db
        // await saveFinalReport(defaultData);

        console.log("✅ Finalize request successful:", result);
        // alert("Finalized and sent to MLNO!");
        setModalMessage("Finalized and sent to MLNO!");
        setModalOpen(true);
        // navigate("/dashboard");
        setTimeout(() => navigate("/dashboard"), 2000);
      } else {
        const err = await response.json();
        console.warn("⚠️ Finalize request failed with status:", response.status, err);
        // alert("Failed to finalize request: " + err?.error);
        setModalMessage("Failed to finalize request: " + err?.error);
        setModalOpen(true);
      }
    } catch (error) {
      console.error("❌ Error finalizing request:", error);
      // alert("Something went wrong while finalizing.");
      setModalMessage("Something went wrong while finalizing.");
      setModalOpen(true);
    }
    finally {
      hideLoader();
    }
  };


  console.log("🔒 isReadOnly:", isReadOnly, typeof isReadOnly);
  console.log("🔍 Debug - MLNOFlag:", MLNOFlag, "diligenceLevel:", diligenceLevel, "Show Override Button:", MLNOFlag && diligenceLevel === "Enhanced");

  return (
    <>


      <div className="transaction-detail " >
        {/* Main Form */}
        <StepTabs searchParams={searchParams} />
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.status}
        />
        <div className="form-section">
        <div className="transaction-form form_information">
          <h2 >Final Review</h2>
          <h4 style={{ margin: "10px 0", fontWeight: "500" }}>Based on the information provided, below are the results:</h4>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div className="form-group" >
              <label>Request Number</label>
              <input type="text" name="Request Number" value={requestId || "Loading..."} disabled />
            </div>

            <div className="form-group">
              <label>Property Name: </label>
              <input type="text" name="Property Name:" value={
                finalReviewInfo.property_name ||
                finalReviewInfo.address_line1 ||
                finalReviewInfo.city ||
                finalReviewInfo.state ||
                finalReviewInfo.postcode ||
                finalReviewInfo.country ||
                "N/A"
              } disabled />

            </div>

          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div className="form-group" >
              <label>Client/Counterparty Name </label>
              <input type="text" name="Request Number" value={finalReviewInfo.entity_name || "N/A"} disabled />

            </div>
            <div className="form-group">
              <label>Company Type</label>
              <input type="text" name="Property Name:" value={finalReviewInfo.entity_type || "N/A"} disabled />

            </div>
            <div
              className="form-group"
              onClick={handleClick}
              style={{ cursor: diligenceLevel === "Enhanced" ? "pointer" : "default" }}
            >
              <label>Diligence Level</label>
              <input
                type="text"
                name="Diligence level"
                value={requsetStatusType}
                disabled={diligenceLevel !== "Enhanced"} // Only clickable when "Enhanced"
                onClick={diligenceLevel === "Enhanced" ? handleClick : undefined}
                className={diligenceLevel === "Enhanced" ? "clickable-input" : ""}
              />
            </div>
            <div className="form-group">
              <label>Request Status</label>
              <input type="text" name="Property Name:" value={requestStatus} disabled />

            </div>

          </div>
          <h4 style={{ margin: "10px 0", fontWeight: "500" }}>Contact Us:</h4>
          <div className="email_button-group" style={{ paddingTop: "0" }}>
            <button type="button" onClick={() => sendMail("MLNO")} disabled={MLNOFlag}>Email MLNO</button>
            <button type="button" onClick={() => sendMail("COD")}>Email COnD</button>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div className="form-group" >
              <label>Required Documents Attached:  </label>
              <input type="text" name="Required Documents" value={requiredDocumentsAttached ? "Yes" : "No"} disabled />

            </div>

          </div>
          <h4 style={{ margin: "20px 0 10px", fontWeight: "700" }}>Validation Status:</h4>
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>Steps</th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>Validation Status</th>
                {MLNOFlag && (
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Transaction Details</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.transaction_status)}
                </td>

                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.transaction_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.transaction_status || "").toLowerCase()
                        )
                          ? "Unlock is disabled until the transaction is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.transaction_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("transaction_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Property Info</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.property_status)}
                </td>

                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.property_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.property_status || "").toLowerCase()
                        )
                          ? "Unlock is disabled until the property is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.property_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("property_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Client/ Counterparty Onboarding</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.entity_status)}
                </td>
                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||

                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.entity_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.entity_status || "").toLowerCase()
                        )
                          ? "Unlock is disabled until this section is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.entity_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}

                      onClick={() => {
                        console.log("🔘 Button clicked!");
                        unlockSection("entity_status");
                      }}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Corporate Structure</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.corporate_structure_status)}
                </td>
                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        // was reading transaction_status — a copy-paste slip, so this
                        // button's enabled state depended on an unrelated section
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.corporate_structure_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.corporate_structure_status || "").toLowerCase()
                        )
                          ? "Unlock is disabled until this section is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.corporate_structure_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("corporate_structure_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Management Structure</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.management_data_status)}
                </td>
                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        // was reading transaction_status — same copy-paste slip as above
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.management_data_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.management_data_status || "").toLowerCase()
                        )
                          ? "Unlock is disabled until this section is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.management_data_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("management_data_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Risk Assessment</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.risk_assessment_status)}

                </td>
                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.transaction_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.risk_assessment_status || "").toLowerCase()
                        ) 
                          ? "Unlock is disabled until this section is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                            (statuses.risk_assessment_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("risk_assessment_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>
           
              

<tr>
  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
    Risk Assessment Continued
  </td>

  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
    {displayStatus(
      riskAssesContObservable.isContinue()
        ? statuses?.risk_assessment_continued_status || "N/A"
        : "N/A"
    )}
  </td>

  {MLNOFlag && (() => {
    // Get raw status value for logic and display fallback
    const rawStatus = riskAssesContObservable.isContinue()
      ? statuses?.risk_assessment_continued_status
      : "N/A";

    // Normalize for logic (internal use only)
    const normalizedStatus = (rawStatus || "N/A").toLowerCase();
    const normalizedRequestStatus = (requestStatus || "").toLowerCase();

    // Decide if button should be disabled
    const disableUnlock = isReadOnly ||
      ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(normalizedStatus) ||
      ["complete", "completed", "deleted"].includes(normalizedRequestStatus);

    // Tooltip logic
    const unlockTitle = ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(normalizedStatus)
      ? "Unlock is disabled until this section is validated."
      : "Click to unlock this section";

    return (
      <td style={{ border: "1px solid #ccc", padding: "8px" }}>
        <button
          disabled={disableUnlock}
          title={unlockTitle}
          style={{
            padding: "4px 8px",
            backgroundColor: "#07b1b0",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            opacity: disableUnlock ? 0.6 : 1,
          }}
          onClick={() => unlockSection("risk_assessment_continued_status")}
        >
          Unlock
        </button>
      </td>
    );
  })()}
</tr>

              
              
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>EDD</td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {displayStatus(statuses.edd_status)}
                </td>
                {MLNOFlag && (
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <button
                      disabled={
                        isReadOnly ||
                        ["n/a", "not applicable", "in progress", "not validated", "not found"].includes(
                          (statuses.transaction_status || "").toLowerCase()
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                      }
                      title={
                        ["n/a", "in progress", "not validated"].includes(
                          (statuses.edd_status || "").toLowerCase() 
                        ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                          ? "Unlock is disabled until this section is validated."
                          : "Click to unlock this section"
                      }
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#07b1b0",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity:
                          ["n/a", "in progress", "not validated"].includes(
                            (statuses.edd_status || "").toLowerCase()
                          ) ||  ["complete", "completed", "deleted"].includes((requestStatus || "").toLowerCase())
                            ? 0.6
                            : 1,
                      }}
                      onClick={() => unlockSection("edd_status")}
                    >
                      Unlock
                    </button>
                  </td>
                )}
              </tr>

            </tbody>

          </table>
          <div>
             <h2 style={{ margin: "10px 0", fontWeight: "500", color: "#07b1b0" }}>User Review Section: </h2>
              


              <div className="form-group">
                <label>Additional User Consideration - PRINTS ON REPORT*</label>
                <textarea
                  value={formData.MLNOCOnsideration}
                  // disabled={isReadOnly}
                  disabled={isReadOnly} // or readOnly={isReadOnly}
                  required

                  name="MLNOCOnsideration" rows="3"
                  onChange={(e) => setFormData({ ...formData, MLNOCOnsideration: e.target.value })}

                />

              </div>
          </div>
          {MLNOFlag && (
            <div>
             
              <h2 style={{ margin: "10px 0", fontWeight: "500", color: "#07b1b0" }}>MLNO Review Section: </h2>
              {(isEddValid || isRiskValid) && (
                <div className="form-group">
                  <label>EDD or Risk Assessment - Continuation Justification (INTERNAL ONLY) *</label>
                  <textarea
                    value={formData.justification}
                    name="Justification"
                    rows="3"
                    onChange={(e) => setFormData({ ...formData, justification: e.target.value })}
                  />
                </div>

              )}
              <div className="form-group">
                <label>MLNO Comments - PRINTS ON REPORT*</label>
                <textarea
                  value={formData.mlnoComments}
                  disabled={isReadOnly}
                  onChange={(e) => setFormData({ ...formData, mlnoComments: e.target.value })}
                  required

                  name="mlnoComments" rows="3" />

              </div>

              <SignatureModal
                isOpen={isSignatureModalOpen}
                sigPad={sigPad}
                saveSignature={saveSignature}
                clearSignature={clearSignature}
                signature={signature}
                handleUploadSignature={handleUploadSignature}
                uploadedSignature={uploadedSignature}
                formData={formData}
                isChecked={isChecked}
                isReadOnly={isReadOnly}
                handleCheckboxChange={handleCheckboxChange}
                handleCancel={handleCancel}
                handleSubmitMLNOReview={handleSubmitMLNOReview}
              />

            </div>
          )}



        </div>
        <RightSidebar
        setRefreshDocs={setRefreshDocs} />
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={handleDeletClose}
          onConfirm={handleDeleteConfirm}
        />

        <LoaderModal isOpen={isLoading} message={loadingMessage} />

      </div>
 
</div>


{/* <BottomBar
  buttons={[
    ...(MLNOFlag
      ? [
          // ✅ Include Save & Complete buttons only when both fields are filled
          ...(formData.MLNOCOnsideration?.trim() && formData.mlnoComments?.trim()
            ? [
                // {
                //   label: "Save",
                //   onClick: saveMLNOComments,
                //   disabled:
                //     isViewMode ||
                //     isReadOnly ||
                //     ["Completed", "Deleted", "Complete"].includes(
                //       requestStatus
                //     ),
                //   title: isViewMode || isReadOnly
                //     ? "You are in view-only mode"
                //     : ["Completed", "Deleted", "Complete"].includes(requestStatus)
                //     ? "Action not allowed in current request status"
                //     : "Save your MLNO comments",
                //   style: { width: "auto" },
                // },
                {
                  label: "Validate & Complete",
                  onClick: handleValidateAndComplete,
                  disabled:
                    isViewMode ||
                    isReadOnly ||
                    !canFinalize ||
                    ["Completed", "Deleted", "Complete"].includes(requestStatus),
                  title: isViewMode || isReadOnly
                    ? "You are in view-only mode"
                    : ["Completed", "Deleted", "Complete"].includes(requestStatus)
                    ? "Action not allowed in current request status"
                    : !canFinalize
                    ? "All Pages need to be validated"
                    : "Validate and Complete",
                  style: { width: "auto" },
                },
              ]
            : []),
          // 📨 Always include Send Back to User
          // {
          //   label: "Send Back to User",
          //   onClick: sendMailToUser,
          //   style: { width: "auto" },
          //   disabled:
          //     isViewMode ||
          //     isReadOnly ||
          //     !isSendBackEnabled ||
          //     ["Completed", "Deleted", "Complete", "In Progress"].includes(requestStatus),
          //   title: isViewMode || isReadOnly
          //     ? "You are in view-only mode"
          //     : ["Completed", "Deleted", "Complete", "In Progress"].includes(requestStatus)
          //     ? "Action not allowed in current request status"
          //     : !isSendBackEnabled
          //     ? "Fill all MLNO fields before sending"
          //     : "Send email to user",
          // },

          {
            label: "Send Back to User",
            onClick: sendMailToUser,
            style: { width: "auto" },
            disabled:
              isViewMode ||
              isReadOnly ||
              !isSendBackEnabled ||
              ["completed", "deleted"].includes((requestStatus || "").toLowerCase()),
          
            title: isViewMode || isReadOnly
              ? "You are in view-only mode"
              : ["completed", "deleted"].includes((requestStatus || "").toLowerCase())
              ? "Action not allowed in current request status"
              : !isSendBackEnabled
              ? "Fill all MLNO fields before sending"
              : "Send email to user",
          },
          // ❌ Delete
          {
            label: "Delete",
            onClick: handleDelete,
            style: { width: "auto", backgroundColor: "red", color: "white" },
            disabled: isViewMode || isReadOnly,
            title: isViewMode || isReadOnly
              ? "You are in view-only mode"
              : "Delete request",
          },
        ]
      : [
          {
            label: "Send To MLNO",
            onClick: sendTOMnlno,
            disabled:
              isViewMode ||
              isReadOnly ||
              !canFinalize ||
              ["Pending MLNO", "Completed", "Deleted", "Complete"].includes(
                requestStatus
              ),
            title: isViewMode || isReadOnly
              ? "You are in view-only mode"
              : "Send To MLNO",
            style: {
              width: "auto",
              backgroundColor:
                !canFinalize ||
                ["Pending MLNO", "Completed", "Deleted", "Complete"].includes(
                  requestStatus
                )
                  ? "grey"
                  : "",
            },
          },
        ]),
    // 📄 Conditionally include report buttons
    ...(requestStatus === "Complete"
      ? [
          {
            label: "Summary Report",
            onClick: handleNext,
            style: { width: "auto" },
          },
          {
            label: "Detail Report",
            onClick: () => navigate("/Report3"),
            style: { width: "auto", backgroundColor: isDisabled ? "grey" : "" },
            disabled: isDisabled,
            title: isDisabled
              ? "Access restricted or data missing"
              : "View detail report",
          },
        ]
      : []),
  ]}
/> */}


<BottomBar
  customContent={
    MLNOFlag && (
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <label style={{ fontWeight: "500", fontSize: "14px", color: "#333" }}>
          Change Diligence Status:
        </label>
        <select
          value={overrideNewStatus}
          onChange={(e) => setOverrideNewStatus(e.target.value)}
          disabled={isReadOnly || ["completed", "deleted"].includes((requestStatus || "").toLowerCase())}
          style={{
            padding: "8px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            fontSize: "14px",
            minWidth: "150px",
            backgroundColor: "#fff",
            cursor: "pointer"
          }}
        >
          <option value="">-- Select New Status --</option>
          <option value="Standard">Standard</option>
          <option value="Simplified">Simplified</option>
          <option value="Enhanced">Enhanced</option>
        </select>
        <button
          onClick={() => {
            if (overrideNewStatus) {
              setShowOverrideModal(true);
            }
          }}
          disabled={!overrideNewStatus || isReadOnly || ["completed", "deleted"].includes((requestStatus || "").toLowerCase())}
          style={{
            padding: "8px 16px",
            backgroundColor: !overrideNewStatus || isReadOnly || ["completed", "deleted"].includes((requestStatus || "").toLowerCase()) ? "#ccc" : "#059a99",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: !overrideNewStatus || isReadOnly ? "not-allowed" : "pointer",
            fontSize: "14px",
            fontWeight: "500",
            minWidth: "100px"
          }}
          title={
            isReadOnly
              ? "You are in view-only mode"
              : ["completed", "deleted"].includes((requestStatus || "").toLowerCase())
              ? "Cannot change status for completed/deleted requests"
              : !overrideNewStatus
              ? "Please select a status first"
              : "Click to change diligence status"
          }
        >
          Apply Change
        </button>
      </div>
    )
  }
  buttons={[
    ...(MLNOFlag
  ? [ {
      label: "Save",
      onClick: saveMLNOComments,
      disabled:
        isViewMode ||
        isReadOnly ||
        ["Completed", "Deleted", "Complete"].includes(
          requestStatus
        ),
      title: isViewMode || isReadOnly
        ? "You are in view-only mode"
        : ["Completed", "Deleted", "Complete"].includes(requestStatus)
        ? "Action not allowed in current request status"
        : "Save your MLNO comments",
      style: { width: "auto" },
    },
      {
        label: "Validate & Complete",
        onClick: handleValidateAndComplete,
        disabled:
          isViewMode ||
          isReadOnly ||
          !canFinalize ||
          !formData.mlnoComments?.trim() ||
          !formData.MLNOCOnsideration?.trim() ||
          ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase()),
        title:
          isViewMode || isReadOnly
            ? "You are in view-only mode"
            : ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase())
            ? "Action not allowed in current request status"
            : !formData.MLNOCOnsideration?.trim()
            ? "Additional User Consideration is required"
            : !formData.mlnoComments?.trim()
            ? "MLNO Comments are required"
            : !canFinalize
            ? "All Pages need to be validated"
            : "Validate and Complete",
        style: { width: "auto" },
      },
      {
        label: "Send Back to User",
        onClick: sendMailToUser,
        style: { width: "auto" },
        disabled:
          isViewMode ||
          isReadOnly ||
          ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase()) ||
          !formData.mlnoComments?.trim(),
        title:
          isViewMode || isReadOnly
            ? "You are in view-only mode"
            : ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase())
            ? "Action not allowed in current request status"
            : !formData.mlnoComments?.trim()
            ? "Fill all MLNO fields before sending"
            : "Send email to user",
      },
      {
        label: "Delete",
        onClick: handleDelete,
        style: { width: "auto", backgroundColor: "red", color: "white" },
        disabled: isViewMode || isReadOnly,
        title: isViewMode || isReadOnly ? "You are in view-only mode" : "Delete request",
      },
    ]
  : [
      ...(["pending mlno"].includes((requestStatus || "").toLowerCase())
        ? [{
            label: "Save",
            onClick: handleSaveUserConsideration,
            skipConfirmation: true,
            disabled:
              isViewMode ||
              isReadOnly ||
              ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase()),
            title:
              isViewMode || isReadOnly
                ? "You are in view-only mode"
                : "Save your comments",
            style: { width: "auto" },
          }]
        : []),
      {
        label: "Save",
        onClick: handleSaveUserConsideration,
        disabled:
          isViewMode ||
          isReadOnly ||
          !formData.MLNOCOnsideration?.trim() ||
          ["completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase()),
        title:
          isViewMode || isReadOnly
            ? "You are in view-only mode"
            : !formData.MLNOCOnsideration?.trim()
            ? "Enter your notes before saving"
            : "Save your notes",
        style: { width: "auto" },
      },
      {
        label: "Send To MLNO",
        onClick: sendTOMnlno,
        disabled:
          isViewMode ||
          isReadOnly ||
          !canFinalize ||
          !formData.MLNOCOnsideration?.trim() ||
          ["pending mlno", "completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase()),
        title:
          isViewMode || isReadOnly
            ? "You are in view-only mode"
            : !formData.MLNOCOnsideration?.trim()
            ? "Additional User Consideration is required"
            : !canFinalize
            ? "All Pages need to be validated"
            : "Send To MLNO",
        style: {
          width: "auto",
          backgroundColor:
            !canFinalize ||
            !formData.MLNOCOnsideration?.trim() ||
            ["pending mlno", "completed", "deleted", "complete"].includes((requestStatus || "").toLowerCase())
              ? "grey"
              : "",
        },
      },
    ]),


    ...(["complete", "completed"].includes((requestStatus || "").toLowerCase())
      ? [
          {
            label: "Download Report",
            onClick: handleDownloadReport,
            style: { width: "auto" },
          },
          {
            label: "Download Documents",
            onClick: handleDownloadDocuments,
            style: { width: "auto", backgroundColor: isDisabled ? "grey" : "" },
            disabled: isDisabled,
            title: isDisabled
              ? "Access restricted or data missing"
              : "View detail report",
          },
        ]
      : []),
  ]}
/>



      <ConfirmationModal
        isOpen={modalOpen}
        heading={modalHeading}
        message={modalMessage}
        onClose={() => setModalOpen(false)}
      />

      {/* MLNO Diligence Change Confirmation Modal */}
      <DiligenceChangeModal
        isOpen={showOverrideModal}
        currentStatus={diligenceLevel}
        newStatus={overrideNewStatus}
        onConfirm={handleOverrideConfirm}
        onClose={() => {
          setShowOverrideModal(false);
          setOverrideNewStatus("");
        }}
      />

      <FloatingQueryCenter />

    </>
  );
};

export default FinalReview;
